var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C12.9778 21 14.9112 20.4135 16.5557 19.3147C18.2002 18.2159 19.4819 16.6541 20.2388 14.8268C20.9957 12.9996 21.1937 10.9889 20.8078 9.0491C20.422 7.10929 19.4696 5.32746 18.0711 3.92894C16.6725 2.53041 14.8907 1.578 12.9509 1.19215C11.0111 0.806299 9.00042 1.00433 7.17316 1.76121C5.3459 2.51808 3.78412 3.79981 2.6853 5.4443C1.58649 7.08879 0.999999 9.02219 0.999999 11",
    stroke: "url(#paint0_angular_137_9181)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_137_9181",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6667 11) rotate(-180) scale(11.6667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.796387,
    stopColor: "#7C01FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996464,
    stopColor: "#7C01FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderSearch);
export default __webpack_public_path__ + "static/media/loader-search.4d005f503f314c3c20964b4c2d1c7ddd.svg";
export { ForwardRef as ReactComponent };